import React from "react";
import { createPortal } from "react-dom";
import createContainer from "../createContainer";
import { Color } from '../utils';
import { ReactComponent as Close } from "./close.svg";

import "./Notification.scss";

const container = createContainer();

let timeToDelete = 300;
let timeToClose = 4000;

export default function Notification({
  color = Color.info,
  autoClose = false,
  onDelete,
  children,
}) {

  const [isClosing, setIsClosing] = React.useState(false);

  React.useEffect(() => {
    if (isClosing) {
      const timeoutId = setTimeout(onDelete, timeToDelete);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isClosing, onDelete]);

  React.useEffect(() => {
    if (autoClose) {
      const timeoutId = setTimeout(() => setIsClosing(true), timeToClose);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [autoClose]);

  return createPortal(
    <div className={"react-notify " + (isClosing ? "react-notify-shrink" : "")}>
      <div
        className={"react-notification react-notification-" + color + " react-notification-" + (!isClosing ? "slideIn " : "slideOut ")}
      >
        {children}

        <button
          onClick={() => setIsClosing(true)}
          className="react-notification-closeButton"
        >
          <Close height={16} />
        </button>
      </div>
    </div>,
    container
  );
}
